import React from 'react';
import { autocompletePopupSlotProps } from './menu/primitives';
import { MUTED } from './tokens';

const nameStyle = {
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const publicLabelStyle = {
  flexShrink: 0,
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '.06em',
  textTransform: 'uppercase',
  color: MUTED,
};

/**
 * Slot props for the picker's popup: the shared popover chrome, plus a width of
 * its own.
 */
export const tagPopperSlotProps = {
  ...autocompletePopupSlotProps,
  popper: { placement: 'bottom-start', style: { width: 'fit-content' } },
  paper: {
    ...autocompletePopupSlotProps.paper,
    sx: [autocompletePopupSlotProps.paper.sx, { minWidth: 200, maxWidth: 'min(340px, 90vw)' }],
  },
};

/**
 * A row in a tag picker. Public tags carry a "public" label on the right.
 */
export default function renderTagOption(props, option) {
  const { key, ...liProps } = props;
  return (
    <li
      key={key}
      {...liProps}
      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
    >
      <span style={nameStyle}>{option.name}</span>
      {option.isPublic && <span style={publicLabelStyle}>public</span>}
    </li>
  );
}
